import axios from "axios";

/**
 * Frontend logger that sends logs to the backend, which then forwards them to Better Stack.
 * 
 * Usage:
 *   import logger from "../utils/logger";
 *   logger.info("Checkout Started", { productId });
 *   logger.error("Payment Failed", { error });
 */
class FrontendLogger {
  constructor() {
    this.apiUrl = process.env.REACT_APP_BACKEND_URL;
  }

  async _log(level, message, metadata = {}) {
    // Also log to console for development
    const consoleMethod = level === "error" ? "error" : level === "warn" ? "warn" : "log";
    console[consoleMethod](`[${level.toUpperCase()}] ${message}`, metadata);

    try {
      if (this.apiUrl) {
        await axios.post(`${this.apiUrl}/log`, {
          level,
          service: "frontend-checkout",
          message,
          metadata: {
            ...metadata,
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
          }
        });
      }
    } catch (err) {
      // Fail silently to not disrupt the user experience
      console.error("Failed to send log to backend:", err.message);
    }
  }

  info(message, metadata) {
    return this._log("info", message, metadata);
  }

  warn(message, metadata) {
    return this._log("warn", message, metadata);
  }

  error(message, metadata) {
    return this._log("error", message, metadata);
  }

  debug(message, metadata) {
    return this._log("debug", message, metadata);
  }
}

export default new FrontendLogger();
